import authReducer from '@app/store/slices/authSlice';
import dealRoomReducer from '@app/store/slices/dealRoomSlice';
import nightModeReducer from '@app/store/slices/nightModeSlice';
import pwaReducer from '@app/store/slices/pwaSlice';
import themeReducer from '@app/store/slices/themeSlice';
import translationReducer from '@app/store/slices/translationsSlice';
import userReducer from '@app/store/slices/userSlice';
import clientReducer from '@app/store/slices/clientSlice';

export default {
  user: userReducer,
  auth: authReducer,
  nightMode: nightModeReducer,
  theme: themeReducer,
  pwa: pwaReducer,
  translation: translationReducer,
  dealRoom: dealRoomReducer,
  client: clientReducer,
};
